import { render } from "./TemplateDefault.vue?vue&type=template&id=66daf7a2"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__